import { Skeleton } from "primereact/skeleton";

import { DetailsContainer } from "../VolanteDetails/VolanteDetailsStyles";
import { SkeletonTable } from "./VolanteAdminStyles";

export const QuotationSkeleton = () => (
  <DetailsContainer>
    <SkeletonTable>
      <tbody>
        {[1, 2, 3].map((i) => (
          <tr key={i}>
            <td colSpan={4}>
              <Skeleton width="100%" height="30px" />
            </td>
          </tr>
        ))}
      </tbody>
    </SkeletonTable>
  </DetailsContainer>
);
